import { useEffect, useState } from 'react';
import { usePost, useGet } from 'hooks';
import { Button, Loader } from 'components/common';
import PasswordChange from '../Reset/PasswordChange';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import {
  verifySetPasswordToken,
  completeSetPassword,
  verifyResetPasswordToken,
  completeReset,
} from 'services/api';
import { Alert } from 'antd';
import React from 'react';

const NewPassword = styled.div`
  display: flex;
  flex-direction: column;
`;

const SetNewPass = ({ code, isTrial, isPartner }) => {
  const [serverError, setServerError] = useState(null);
  const [passwordSecurityError, setPasswordSecurityError] = useState(null);
  const { push } = useHistory();

  const expiredCodeMessage = (
    <span>
      That link has been used or has expired.{' '}
      <a href='/login'>Click here to login</a> or talk to us using the chat
      service below.
    </span>
  );

  const isSetPassword = isTrial || isPartner;
  const [{ res: codeIsValid, loading: verificationLoading }] = useGet({
    url: isSetPassword
      ? verifySetPasswordToken(code)
      : verifyResetPasswordToken(code),
    onMount: true,
  });

  const handleLogin = () => {
    push('/login');
  };

  const [newPass, setNewPass] = useState('');
  const [
    hasClientSidePasswordErrors,
    setHasClientSidePasswordErrors,
  ] = useState(false);

  const [confirmPass, setConfirmPass] = useState('');

  const [{ res, loading, error }, postReset] = usePost({
    url: isSetPassword ? completeSetPassword : completeReset,
  });

  const handleReset = () => {
    setServerError(null);
    setPasswordSecurityError(null);
    if (!hasClientSidePasswordErrors) {
      postReset({ code, password: newPass });
    }
  };

  useEffect(() => {
    if (error) {
      setServerError(error);
    }
  }, [error]);

  useEffect(() => {
    setServerError(null);
    setPasswordSecurityError(null);
  }, [newPass, setServerError, setPasswordSecurityError]);

  if (res) {
    return (
      <NewPassword>
        <p>Your password was set successfully.</p>
        <Button onClick={handleLogin}>Go to Login</Button>
      </NewPassword>
    );
  }
  return (
    <React.Fragment>
      {code && !verificationLoading && codeIsValid && (
        <PasswordChange
          serverError={serverError}
          passwordSecurityError={passwordSecurityError}
          newPass={newPass}
          loading={loading}
          setNewPass={setNewPass}
          onChange={setHasClientSidePasswordErrors}
          handleSubmit={handleReset}
          setPasswordSecurityError={setPasswordSecurityError}
          confirmPass={confirmPass}
          setConfirmPass={setConfirmPass}
        />
      )}
      {!codeIsValid && !verificationLoading && (
        <React.Fragment>
          <Alert message={expiredCodeMessage} type='error' />
          <Button onClick={handleLogin}>Go to Login</Button>
        </React.Fragment>
      )}
      {verificationLoading && <Loader />}
    </React.Fragment>
  );
};
export default SetNewPass;
